import { useTranslation } from "react-i18next";
import { Drawer } from "melco-ui";
import { AddFontsList } from "./AddFontsList";

type AddFontsDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
};

export const AddFontsDrawer: React.FC<AddFontsDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      title={t("libraries.fonts.embroidery.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: 0 }}
    >
      <AddFontsList />
    </Drawer>
  );
};
